<template>
    <v-container>
        <v-layout>
            <v-flex class="text-center">
                <h2 class="titulo mb-12">Cadastro de conta bancária</h2>
            </v-flex>
        </v-layout>
        <v-row wrap class="row-padding">
            <v-flex col xs12 md6 v-if="ha_bancos_devolucao_disponiveis">
                <p class="text-devolucao">Devolução em conta bancária*</p>
                <label class="grey--text">Autorizo o cadastro da conta bancária para créditos</label>
                <v-radio-group ref="devolucao_radio"
                               id="GroupDevolucao"
                               v-model="pedido.dados_bancarios.devolucao.autorizacao"
                               :disabled="pedido.dados_bancarios.devolucao.bloqueado === true"
                               :rules="[$rules.selected]" row>
                    <v-radio id="RadioAutorizo" label="Autorizo" :value="true" />
                    <v-radio id="RadioNaoAutorizo" label="Não Autorizo" :value="false" />
                </v-radio-group>
                <m-form ref="devolucao_bancaria" v-if="pedido.dados_bancarios.devolucao.autorizacao === true">
                    <v-flex xs12>
                        <Autocomplete
                                id="FieldBanco"
                                :disabled="pedido.dados_bancarios.devolucao.bloqueado === true"
                                :items="bancos"
                                v-model="pedido.dados_bancarios.devolucao.banco"
                                return-object
                                :item-text="bancoText"
                                class="required"
                                label="Banco:"
                                outlined
                                @input="checkBlockedReturnAccount()"
                                :rules="[$rules.haveIdBanco]"
                                placeholder="Selecione um banco" />
                    </v-flex>
                    <v-layout class="position-relative">
                        <v-flex v-bind:xs7="!block_account_return_digit" v-bind:xs12="block_account_return_digit">
                            <m-text-field flat
                                          id="FieldNumeroAgencia"
                                          :disabled="pedido.dados_bancarios.devolucao.bloqueado === true"
                                          outlined
                                          label="Número da agência:"
                                          :rules="[$rules.required, $rules.notzero]"
                                          v-mask="'####'"
                                          class="mt-2 required"
                                          v-model="pedido.dados_bancarios.devolucao.numero_agencia"
                            />
                        </v-flex>
                        <v-flex v-if="!block_account_return_digit" v-bind:xs5="!block_account_return_digit" class="ml-4">
                            <m-text-field flat
                                          id="FieldDigitoAgencia"
                                          :disabled="pedido.dados_bancarios.devolucao.bloqueado === true"
                                          label="Dígito agência:"
                                          outlined
                                          class="mt-2"
                                          v-model="pedido.dados_bancarios.devolucao.digito_agencia"
                                          v-mask="'##'" />
                        </v-flex>
                        <div class="digit-tooltip-container" v-if="block_account_return_digit">
                            <v-tooltip dark left color="white">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <div class="d-flex">
                                            <v-icon size="18" class="ml-2" color="primary">mdi-help-box</v-icon>
                                        </div>
                                    </span>
                                </template>
                                <div style="color:#222">
                                    O banco selecionado não possui dígito de agência.
                                </div>
                            </v-tooltip>
                        </div>
                    </v-layout>
                    <v-layout>
                        <v-flex xs7>
                            <m-text-field
                                    id="FieldNumeroConta"
                                    flat
                                    :disabled="pedido.dados_bancarios.devolucao.bloqueado === true"
                                    outlined
                                    v-mask="'##############################'"
                                    label="Número da conta:"
                                    class="mt-2 required"
                                    :rules="[$rules.required, $rules.notzero]"
                                    v-model="pedido.dados_bancarios.devolucao.numero_conta" />
                        </v-flex>
                        <v-flex xs5 class="ml-4 position-relative">
                            <m-text-field
                                    id="FieldDigitoConta"
                                    flat
                                    :disabled="pedido.dados_bancarios.devolucao.bloqueado === true"
                                    outlined
                                    label="Dígito conta:"
                                    v-mask="'##'"
                                    class="mt-2 required"
                                    :rules="[$rules.required]"
                                    v-model="pedido.dados_bancarios.devolucao.digito_conta" />
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex class="ml-4">
                            <label class="text-label">Tipo Conta *</label>
                            <v-radio-group id="GroupTipoConta" v-model="pedido.dados_bancarios.devolucao.tipo_conta" row :disabled="pedido.dados_bancarios.devolucao.bloqueado === true"
                                           :rules="[$rules.required]">
                                <v-radio id="RadioCorrente" label="Corrente" value="corrente" />
                                <v-radio id="RadioPoupanca" label="Poupança" value="poupanca" />
                            </v-radio-group>
                        </v-flex>
                    </v-layout>
                </m-form>
            </v-flex>
            <v-flex col xs12 md6 v-if="ha_bancos_debito_automatico_disponiveis">
                <p class="text-devolucao">Débito automático em conta bancária*</p>
                <label class="grey--text">Autorizo débito automático para próximas parcelas</label>
                <v-radio-group id="DebitoGroupAutorizacao" ref="debito_radio" v-model="pedido.dados_bancarios.debito_conta.autorizacao"
                               :rules="[$rules.selected]" row>
                    <v-radio id="DebitoRadioAutorizo" label="Autorizo" :value="true" />
                    <v-radio id="DebitoRadioNaoAutorizo" label="Não Autorizo" :value="false" />
                </v-radio-group>
                <m-form ref="debito_automatico" v-if="pedido.dados_bancarios.debito_conta.autorizacao === true">
                    <v-flex>
                        <v-checkbox v-if="ha_bancos_devolucao_disponiveis && ha_bancos_debito_automatico_disponiveis && temBancoComumEntreDebitoEDevolucao" id="DebitoCheckMesmaConta" @change="toggleMesmaConta" :disabled="!pedido.dados_bancarios.devolucao.autorizacao || !ha_bancos_debito_automatico_disponiveis"
                                    v-model="pedido.utilizar_mesma_conta"
                                    label="Utilizar mesma conta da devolução bancária: " />
                    </v-flex>
                    <v-flex xs12>
                        <Autocomplete outlined
                                      id="DebitoFieldBanco"
                                      :items="bancos_debito"
                                      :item-text="bancoText"
                                      :rules="pedido.utilizar_mesma_conta ? [] : [$rules.haveIdBanco]"
                                      :disabled="pedido.utilizar_mesma_conta"
                                      class="required"
                                      return-object
                                      label="Banco: "
                                      placeholder="Selecione um banco"
                                      @input="checkBlockedDebitBankAccount()"
                                      v-model="pedido.dados_bancarios.debito_conta.banco" />
                    </v-flex>
                    <v-layout class="position-relative">
                        <v-flex v-bind:xs7="!block_debit_bank_digit" v-bind:xs12="block_debit_bank_digit">
                            <m-text-field
                                    id="DebitoFieldNumeroAgencia"
                                    flat
                                    outlined
                                    :disabled="pedido.utilizar_mesma_conta"
                                    :rules="[$rules.required, $rules.notzero]"
                                    label="Número da agência:"
                                    class="mt-2 required"
                                    v-model="pedido.dados_bancarios.debito_conta.numero_agencia"
                                    v-mask="'####'" />
                        </v-flex>
                        <v-flex v-if="!block_debit_bank_digit" xs5 class="ml-4">
                            <m-text-field
                                    id="DebitoFieldDigitoAgencia"
                                    flat
                                    outlined
                                    :disabled="pedido.utilizar_mesma_conta"
                                    label="Dígito agência:"
                                    v-mask="'##'"
                                    class="mt-2"
                                    v-model="pedido.dados_bancarios.debito_conta.digito_agencia" />
                        </v-flex>
                        <div class="digit-tooltip-container" v-if="block_debit_bank_digit">
                            <v-tooltip left color="white">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <div class="d-flex">
                                            <v-icon size="18" class="ml-2" color="primary">mdi-help-box</v-icon>
                                        </div>
                                    </span>
                                </template>
                                <div style="color:#222">
                                    O banco selecionado não possui dígito de agência.
                                </div>
                            </v-tooltip>
                        </div>
                    </v-layout>
                    <v-layout>
                        <v-flex xs7>
                            <m-text-field
                                    id="DebitoFieldNumeroConta"
                                    flat
                                    outlined
                                    :disabled="pedido.utilizar_mesma_conta"
                                    label="Número da conta: "
                                    v-input-filter="[$filters.numeric]"
                                    :rules="[$rules.required]"
                                    v-mask="'##############################'"
                                    class="mt-2 required"
                                    v-model="pedido.dados_bancarios.debito_conta.numero_conta" />
                        </v-flex>
                        <v-flex xs5 class="ml-4">
                            <m-text-field
                                    id="DebitoFieldDigitoConta"
                                    flat
                                    label="Dígito conta: "
                                    v-input-filter="[$filters.numeric]"
                                    :disabled="pedido.utilizar_mesma_conta"
                                    :rules="[$rules.required]"
                                    outlined
                                    class="mt-2 required"
                                    v-mask="'##'"
                                    v-model="pedido.dados_bancarios.debito_conta.digito_conta" />
                        </v-flex>
                    </v-layout>
                </m-form>
            </v-flex>
        </v-row>
        <v-col cols="12" v-if="dadosCarregados && !ha_bancos_debito_automatico_disponiveis && !ha_bancos_devolucao_disponiveis">
            <v-alert class="d-flex flex-column align-center" type="warning" icon="mdi-alert-circle-outline" dense outlined>
                Nenhuma conta bancária disponível para devolução ou débito automático.
            </v-alert>
        </v-col>
        <v-col class="text-center red--text mb-6" v-if="ha_bancos_debito_automatico_disponiveis || ha_bancos_devolucao_disponiveis">
            Campos obrigatórios *
        </v-col>
        <v-layout class="justify-space-between">
            <v-btn id="ButtonVoltar" color="secondary" class="ma-2" @click="voltar()" text style="margin-left: 0;">Voltar</v-btn>
            <v-btn id="ButtonContinuar" color="primary" class="ma-2" @click="salvar()">Continuar</v-btn>
        </v-layout>
        <v-dialog fullscreen hide-overlay scrollable transition="dialog-bottom-transition" v-model="dialog_pdf">
            <v-card>
                <v-toolbar dark color="primary" class="flex-grow-0" height="50px">
                    <v-btn icon dark @click="dialog_pdf = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Regulamento</v-toolbar-title>
                    <div class="flex-grow-1"></div>
                </v-toolbar>
                <v-layout v-if="dialog_pdf">
                    <embed :src="pdf" alt="pdf" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" width="100%">
                </v-layout>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
  import { alert, notification } from '@/plugins/helpers'
  import { TipoConta, BankTypes } from '@/plugins/constants'
  import { mapState } from 'vuex'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import { get, isEmpty, pick } from 'lodash'
  import { AlertTypes } from '@/plugins/alerts_types'

  const conta_default = {
    id_dados_bancarios: 0,
    banco: null,
    numero_agencia: '',
    digito_agencia: '',
    numero_conta: '',
    digito_conta: '',
    tipo_conta: TipoConta.Corrente,
    bloqueado: false
  }

  const newConDadosBancarioMap = {
    ID_Banco: {
      key: 'banco',
      value: (val, self) => {
        return self.bancos.find(banco => banco.id_banco === val)
      }
    },
    NO_Agencia: {
      key: 'numero_agencia',
      value: val => val
    },
    DG_Agencia: {
      key: 'digito_agencia',
      value: val => val
    },
    ID_Tipo_Conta: {
      key: 'tipo_conta',
      value: val => val === 'P' ? TipoConta.Poupanca : TipoConta.Corrente
    },
    NO_Conta_Corrente: {
      key: 'numero_conta',
      value: val => val
    },
    DG_Conta_Corrente: {
      key: 'digito_conta',
      value: val => val
    }
  }

  export default {
    name: 'DadosBancarios',
    props: { value: Object },
    data: () => ({
      block_debit_bank_digit: false,
      block_account_return_digit: false,
      dadosCarregados: false,
      pedido: {
        cliente: {
          id_cliente: 0,
          id_pessoa_erp: null
        },
        id_pedido: null,
        dados_bancarios: {
          devolucao: { autorizacao: null, ...conta_default },
          debito_conta: { autorizacao: null, ...conta_default }
        },
        utilizar_mesma_conta: false
      },
      pdf: '',
      dialog_pdf: false,
      bancos: [],
      bancos_debito: [],
      banksWithBlockedDigit: []
    }),
    computed: {
      ...mapState(['jornada_venda']),
      ha_bancos_devolucao_disponiveis () {
        return this.bancos && this.bancos.length > 0
      },
      ha_bancos_debito_automatico_disponiveis () {
        return this.bancos_debito && this.bancos_debito.length > 0
      },
      bancos_debito () {
        return this.bancos.filter(banco => banco.debito)
      },
      dados_conta_devolucao () {
        return {
          'banco': this.pedido.dados_bancarios.devolucao.banco,
          'numero_agencia': this.pedido.dados_bancarios.devolucao.numero_agencia,
          'digito_agencia': this.pedido.dados_bancarios.devolucao.digito_agencia,
          'numero_conta': this.pedido.dados_bancarios.devolucao.numero_conta,
          'digito_conta': this.pedido.dados_bancarios.devolucao.digito_conta
        }
      },
      ...mapState([
        'id_ponto_venda'
      ]),
      debit_banks_blocked_digits () {
        return this.banksWithBlockedDigit.filter((bank) => { return bank.tipo_banco === BankTypes.debito_automatico })
      },
      account_return_blocked_digits () {
        return this.banksWithBlockedDigit.filter((bank) => { return bank.tipo_banco === BankTypes.devolucao })
      },
      temBancoComumEntreDebitoEDevolucao () {
        if (!this.bancos_debito || !this.bancos || this.bancos_debito.length === 0 || this.bancos.length === 0) {
          return false
        }
        return this.bancos_debito.some(bancoDebito => this.bancos.some(bancoDevolucao => bancoDevolucao.id_banco === bancoDebito.id_banco))
      }
    },
    watch: {
      'pedido.dados_bancarios.devolucao.autorizacao' (autorizou) {
        if (autorizou && !this.isContaEmpty(this.pedido.dados_bancarios.devolucao)) {
          this.pedido.utilizar_mesma_conta = this.contasIguais(
            this.pedido.dados_bancarios.devolucao,
            this.pedido.dados_bancarios.debito_conta
          )
        } else {
          this.pedido.utilizar_mesma_conta = false
        }
        if (autorizou) {
          if (this.bancos.length === 1) {
            this.pedido.dados_bancarios.devolucao.banco = this.bancos[0]
          }
        } else {
          this.pedido.dados_bancarios.devolucao.banco = null
        }
      },
      'pedido.dados_bancarios.devolucao.tipo_conta' (tipo_conta) {
        if (tipo_conta === TipoConta.Poupanca && this.pedido.utilizar_mesma_conta) {
          Object.assign(this.pedido.dados_bancarios.debito_conta, conta_default)
          this.pedido.utilizar_mesma_conta = false
          this.$refs.debito_automatico.resetValidation()
        }
      },
      'pedido.dados_bancarios.debito_conta.autorizacao' (autorizou) {
        if (autorizou) {
          if (this.bancos_debito.length === 1) {
            this.pedido.dados_bancarios.debito_conta.banco = this.bancos_debito[0]
          }
        } else {
          this.pedido.dados_bancarios.debito_conta.banco = null
        }
      }
    },
    async mounted () {
      this.pedido = Object.assign({}, this.pedido, this.value)
      this.loadBancos()
        .then(() => {
          this.loadDados()
        })
      await this.getBanksConfig()
    },
    methods: {
      checkBlockedReturnAccount () {
        const id_banco = this.pedido.dados_bancarios.devolucao?.banco?.id_banco
        if (this.account_return_blocked_digits.some((bank) => bank.id_banco === id_banco)) {
          this.block_account_return_digit = true
        } else {
          this.block_account_return_digit = false
        }
      },
      checkBlockedDebitBankAccount () {
        const id_banco = this.pedido.dados_bancarios.debito_conta?.banco?.id_banco
        if (this.debit_banks_blocked_digits.some((bank) => bank.id_banco === id_banco)) {
          this.block_debit_bank_digit = true
        } else {
          this.block_debit_bank_digit = false
        }
      },
      bancoText: b => `${('000' + b.codigo).substr(-3)} - ${b.nome}`,
      openPdf () {
        this.$http.get('/dadosbancarios/pdf', { params: { 'ID_Ponto_Venda': this.id_ponto_venda, 'ID_Produto': this.pedido.produto.id_produto } })
          .then(result => {
            const base64pdf = get(result.data, 'PDF_Regulamento', false)
            if (base64pdf) {
              this.pdf = 'data:application/pdf;base64,' + result.data['PDF_Regulamento']
              this.dialog_pdf = true
            } else {
              throw result
            }
          })
          .catch(err => notification('error', err, 'Não foi possível carregar o PDF!'))
      },
      async getBanksConfig () {
        await this.$http.get('/banks_digit_config').then((result) => {
          this.banksWithBlockedDigit = result.data.banks
        })
      },
      parseBanco (data) {
        const dados_bancario = {}
        dados_bancario.bloqueado = false
        dados_bancario.id_dados_bancarios = 0

        Object.keys(newConDadosBancarioMap).forEach(newConKey => {
          const rawValue = data[newConKey]
          const modelMap = newConDadosBancarioMap[newConKey]
          if (rawValue) {
            dados_bancario[modelMap.key] = modelMap.value(rawValue, this)
            dados_bancario.bloqueado = true
            dados_bancario.autorizacao = true
          }
        })

        if (Object.keys(dados_bancario).length > 2) {
          this.pedido.dados_bancarios.devolucao = dados_bancario
        }
      },
      loadDadosNewCon () {
        if (this.pedido.dados_bancarios.devolucao.id_dados_bancarios === 0 && this.pedido.dados_bancarios.debito_conta.id_dados_bancarios === 0 && this.pedido.cliente.id_pessoa_erp) {
          this.$http.get('/clientes/dadosbancarios', { params: { ID_Pessoa: this.pedido.cliente.id_pessoa_erp } }).then(result => {
            this.pedido.dados_bancarios.devolucao.bloqueado = false
            this.pedido.dados_bancarios.devolucao.id_dados_bancarios = 0
            this.parseBanco(result.data)
          })
        }
      },
      loadDados () {
        const url = `/dadosbancarios/${this.pedido.cliente.id_cliente}/${this.pedido.id_pedido}`

        this.$http.get(url)
          .then(res => {
            const { devolucao, debito, dados_bancarios_gerais } = res.data

            if (devolucao && devolucao.id_dados_bancarios) {
              const bancoDevolucao = this.bancos.find(banco => banco.id_banco === devolucao.id_banco) || null

              this.pedido.dados_bancarios.devolucao = { ...this.pedido.dados_bancarios.devolucao, ...devolucao, banco: bancoDevolucao, autorizacao: devolucao.autorizacao === 1 }
            } else if (dados_bancarios_gerais.length > 0) {
              const bancoGeral = this.bancos.find(banco => banco.id_banco === dados_bancarios_gerais[0].id_banco) || null

              this.pedido.dados_bancarios.devolucao = { ...this.pedido.dados_bancarios.devolucao, ...conta_default, ...dados_bancarios_gerais[0], banco: bancoGeral, autorizacao: null }
            }

            if (debito && debito.id_dados_bancarios) {
              const bancoDebito = this.bancos.find(banco => banco.id_banco === debito.id_banco) || null
              this.pedido.dados_bancarios.debito_conta = { ...this.pedido.dados_bancarios.debito_conta, ...debito, banco: bancoDebito, autorizacao: debito.autorizacao === 1 }
              const BancoEstaPresenteNaListaDeBancos = this.bancos_debito.find(dados => dados.id_banco === debito.id_banco)

              if (BancoEstaPresenteNaListaDeBancos) {
                this.pedido.dados_bancarios.debito_conta = { ...this.pedido.dados_bancarios.debito_conta, ...debito, banco: bancoDebito, autorizacao: debito.autorizacao === 1 }
              } else if (!this.ha_bancos_debito_automatico_disponiveis) {
                notification('warning', 'Não identificado cadastro de bancos disponíveis para débito automático')
              }
            } else if (dados_bancarios_gerais.length > 0) {
              const bancoGeral = this.bancos.find(banco => banco.id_banco === dados_bancarios_gerais[0].id_banco) || null

              this.pedido.dados_bancarios.debito_conta = { ...this.pedido.dados_bancarios.debito_conta, ...conta_default, ...dados_bancarios_gerais[0], banco: bancoGeral, autorizacao: null }
            }
            this.dadosCarregados = true
          })
          .catch(() => {
            this.dadosCarregados = true
          })
      },
      async loadBancos () {
        const id_empresa = this.$session.get('id_empresa')
        const id_unidade_negocio = this.$session.get('id_unidade_negocio')
        const flavor = this.$session.get('flavor')
        try {
          const response = await this.$http.post('/bancos-liberados', {
            id_empresa,
            id_unidade_negocio,
            flavor
          })

          this.bancos = response.data.bancos_devolucao || []
          this.bancos_debito = response.data.bancos_debito_automatico || []
        } catch (error) {
          console.error('Erro ao buscar bancos:', error)
          notification(AlertTypes.ERROR, 'Erro ao carregar os bancos disponíveis.')
          this.bancos = []
          this.bancos_debito = []
        }
      },
      toggleMesmaConta () {
        let msg_erro = ''
        if (this.pedido.utilizar_mesma_conta) {
          const bancoPermiteDebito = this.bancos_debito?.some(banco => {
            return banco.id_banco === this.pedido.dados_bancarios.devolucao.banco.id_banco
          })
          let form_devolucao = this.$refs.devolucao_bancaria
          if (!form_devolucao.validate()) {
            msg_erro = 'Para copiar os dados é necessário preencher o formulario de devolução bancária antes.'
          } else if (!bancoPermiteDebito) {
            msg_erro = 'O banco selecionado não permite débito em conta.'
          } else if (this.pedido.dados_bancarios.devolucao.tipo_conta === TipoConta.Poupanca) {
            msg_erro = 'Não é possível utilizar conta poupança para débito automático.'
          } else {
            // Remove id_dados_bancarios da devolucao antes de dar merge com debito
            const { id_dados_bancarios, ...devolucao } = this.pedido.dados_bancarios.devolucao
            this.pedido.dados_bancarios.debito_conta = { ...this.pedido.dados_bancarios.debito_conta, ...devolucao, debito_automatico: true }
            this.pedido.dados_bancarios.debito_conta.bloqueado = false
          }
        } else {
          this.pedido.dados_bancarios.debito_conta = { ...this.pedido.dados_bancarios.debito_conta, ...conta_default }
        }

        if (msg_erro) {
          notification(AlertTypes.INFO, msg_erro)
          // Sem o nextTick o componente checkbox não atualiza a view, apesar de o model atualizar
          this.$nextTick(() => {
            this.pedido.utilizar_mesma_conta = false
          })
        }
      },
      salvar () {
        if (this.formularioValido()) {
          if (this.DebitoAutomaticoTemDigitoBloqueadoEUtilizandoMesmaConta(this.block_debit_bank_digit, this.pedido.utilizar_mesma_conta)) {
            this.pedido.dados_bancarios.debito_conta.digito_agencia = ''
          }

          this.sendAnalytics()
          this.$http.post(`/dadosbancarios`, this.pedido)
            .then(res => {
              if (res.data.devolucao) {
                this.pedido.dados_bancarios.devolucao = { ...this.pedido.dados_bancarios.devolucao, ...res.data.devolucao }
              }
              if (res.data.debito) {
                this.pedido.dados_bancarios.debito_conta = { ...this.pedido.dados_bancarios.debito_conta, ...res.data.debito }
              }
              this.$http.get(`/vendas/assinaturaobrigatoria/${this.pedido.id_pedido}`)
                .then(res => {
                  this.pedido.assinatura_obrigatoria = res.data.ok

                  this.$emit('input', this.pedido)
                  this.$emit('nextPage')
                })
                .catch(err => notification('error', err, 'Não foi possível buscar informações do pedido'))
            })
            .catch(err => notification('error', err, 'Não foi possível salvar os dados bancários'))
        }
      },
      sendAnalytics () {
        sendAnalyticsEvent(this.$gtag, 'confirmar_ContaBancaria', {
          cadastro_conta: this.pedido.dados_bancarios.devolucao.autorizacao ? 'Sim' : 'Não',
          debito_automatico: this.pedido.dados_bancarios.debito_conta.autorizacao ? 'Sim' : 'Não',
          source_menu: this.jornada_venda
        })
      },
      DebitoAutomaticoTemDigitoBloqueadoEUtilizandoMesmaConta (digito_bloqueado, mesma_conta) {
        return digito_bloqueado && mesma_conta
      },
      formularioValido () {
        const radio_devolucao = this.$refs.devolucao_radio
        const debito_radio = this.$refs.debito_radio

        // O método validate recebe um parâmetro boolean 'force', que quando true força exibição do label de erro e pinta o componente de vermelho
        const preencheu_devolucao = radio_devolucao ? radio_devolucao.validate(true) : true
        const preencheu_debito = debito_radio ? debito_radio.validate(true) : true
        // São criadas as variáveis para forçar a execução dos dois métodos. Se colocar a chamada dos métodos na condição do if e o primeiro der false, o segundo não executao
        if (preencheu_devolucao && preencheu_debito) {
          const form_devolucao = this.$refs.devolucao_bancaria
          const form_debito = this.$refs.debito_automatico

          const devolucao_autorizada = this.pedido.dados_bancarios.devolucao?.autorizacao
          const debito_autorizado = this.pedido.dados_bancarios.debito_conta?.autorizacao

          const devolucao_valido = !devolucao_autorizada || (form_devolucao && form_devolucao.validate())
          const debito_valido = !debito_autorizado || (form_debito && form_debito.validate())

          return devolucao_valido && debito_valido
        }
        return false
      },
      contasIguais (conta1, conta2) {
        const colunas_para_comparar = [
          'banco.id_banco',
          'numero_agencia',
          'digito_agencia',
          'numero_conta',
          'digito_conta',
          'tipo_conta'
        ]

        return JSON.stringify(pick(conta1, colunas_para_comparar)) === JSON.stringify(pick(conta2, colunas_para_comparar))
      },
      isContaEmpty (conta) {
        return isEmpty(conta.numero_agencia) &&
          isEmpty(conta.digito_agencia) &&
          isEmpty(conta.numero_conta) &&
          isEmpty(conta.digito_conta)
      },
      voltar () {
        alert({
          text: 'Tem certeza que deseja sair da tela de dados bancários? \nOs dados atuais não serão salvos.',
          buttons: {
            'Cancelar': () => true,
            'Confirmar': () => this.$emit('prevPage')
          }
        })
      }
    }
  }
</script>

<style scoped type="scss">
    .text-devolucao {
        margin: 12px 0;
        font-size: 18px;
        color: var(--primary);
        font-weight: bold;
    }
    .digit-tooltip-container{
      position: absolute;
      display: block;
      top: -20px;
      right: 0px;

    }
    .text-label {
        font-size: 18px;
        color: #adadad;
    }

</style>
